import { useModal } from '@shared/model/useModal';

/**
 * Модалка выбора файла: «Мои файлы» (уже загруженные) или «С устройства».
 *
 * open({
 *   onSelect: (items) => {},  // (File | Attachment)[]
 *   multiple = false,
 *   maxFiles = 5,
 * })
 */
export const useAttachFileModal = () => useModal('attach-file');
